const homeFeaturesByLang = {
  en: [
    {
      icon: '⚙️',
      iconBg: '#fef2f2',
      title: 'Fully Configurable for Your Business',
      description: 'Adapt every layer of SAPOT AI to match your business logic and processes.',
      link: 'Configure your workflow',
      image: '/images/fully_configurable.png',
    },
    {
      icon: '📈',
      iconBg: '#EFF6FF',
      title: 'AI Performance Scoring',
      description: 'Measure performance, identify gaps, and drive continuous improvement with AI-powered scoring.',
      link: 'Score smarter',
      image: '/images/dashboard.png',
    },
    {
      icon: '🔄',
      iconBg: '#F0FDF4',
      title: 'Automated Sync & Intelligent Highlighting',
      description: 'Sync conversations in real time and extract meaningful insights automatically.',
      link: 'Automate insights',
      image: '/images/auto_sync.png',
    },
    {
      icon: '🧠',
      iconBg: '#FAF5FF',
      title: 'AI-Powered Data Analysis',
      description: 'Turn conversations into actionable insights with AI-driven analysis.',
      link: 'Analyze with AI',
      image: '/images/ai_analysis.png',
    },
  ],
  zh: [
    {
      icon: '⚙️',
      iconBg: '#fef2f2',
      title: '完全贴合业务的灵活配置',
      description: '深度定制 SAPOT AI 的每一层,完美匹配您的业务逻辑与流程。',
      link: '配置您的工作流',
      image: '/images/fully_configurable.png',
    },
    {
      icon: '📈',
      iconBg: '#EFF6FF',
      title: 'AI 绩效评分',
      description: '用 AI 评分量化团队表现、识别短板、持续提升销售战斗力。',
      link: '更智能的评分',
      image: '/images/dashboard.png',
    },
    {
      icon: '🔄',
      iconBg: '#F0FDF4',
      title: '自动同步与智能标注',
      description: '实时同步销售对话,自动提取关键洞察,释放团队生产力。',
      link: '自动化洞察',
      image: '/images/auto_sync.png',
    },
    {
      icon: '🧠',
      iconBg: '#FAF5FF',
      title: 'AI 驱动的数据分析',
      description: '将每一通对话转化为可落地的行动建议,让数据驱动增长。',
      link: 'AI 深度分析',
      image: '/images/ai_analysis.png',
    },
  ],
};

const homeBottomFeatureByLang = {
  en: {
    title: 'Fewer Tools, Smarter Sales',
    description: 'Cut manual work while keeping your team focused, data-driven, and high-performing.',
    link: 'Unlock your savings',
    stats: [
      { value: '10x', label: 'operational efficiency' },
      { value: '39%', label: 'more productive' },
      { value: '70%', label: 'cost savings' },
    ],
  },
  zh: {
    title: '少即是多,销售更聪明',
    description: '减少重复劳动,让团队专注于高价值工作,数据驱动、业绩领先。',
    link: '立即释放成本红利',
    stats: [
      { value: '10x', label: '运营效率提升' },
      { value: '39%', label: '生产力提升' },
      { value: '70%', label: '成本节省' },
    ],
  },
};

export const getHomeFeatures = (lang = 'en') =>
  homeFeaturesByLang[lang] || homeFeaturesByLang.en;

export const getHomeBottomFeature = (lang = 'en') =>
  homeBottomFeatureByLang[lang] || homeBottomFeatureByLang.en;

// Back-compat named exports (default to English)
export const homeFeatures = homeFeaturesByLang.en;
export const homeBottomFeature = homeBottomFeatureByLang.en;
